import { useThemeColors } from '../hooks/useThemeColors'

export default function ServerError() {
  const c = useThemeColors()

  function handleRefresh() {
    window.location.reload()
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: c.bgPrimary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: '480px' }}>
        <div
          style={{
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: '11px',
            fontWeight: 500,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: '#DC2626',
            marginBottom: '16px',
          }}
        >
          500 — SOMETHING WENT WRONG
        </div>
        <h1
          style={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 800,
            fontSize: '52px',
            letterSpacing: '-0.03em',
            color: c.textPrimary,
            margin: '0 0 16px',
            lineHeight: 1.05,
          }}
        >
          Server error
        </h1>
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '18px',
            color: c.textMuted,
            maxWidth: '400px',
            margin: '0 auto 32px',
            lineHeight: 1.6,
          }}
        >
          We've been notified. Try refreshing the page.
        </p>
        <button
          onClick={handleRefresh}
          style={{
            background: c.signal,
            border: 'none',
            borderRadius: '2px',
            padding: '10px 24px',
            fontFamily: 'Inter, sans-serif',
            fontSize: '15px',
            fontWeight: 600,
            color: c.textPrimary,
            cursor: 'pointer',
            transition: 'background 150ms',
          }}
          onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = c.signalHover }}
          onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = c.signal }}
        >
          Refresh
        </button>
      </div>
    </div>
  )
}
